<template>
  <van-dialog
    theme="round-button"
    class="custom-dialog"
    v-model="show"
    :title="data.title"
    :show-confirm-button="data.showConfirmButton"
    :show-cancel-button="data.showCancelButton"
    :confirm-button-text="data.isConfirmDelay ? confirmButtonText : data.confirmButtonText"
    :cancel-button-text="data.isCancelDelay ? cancelButtonText : data.cancelButtonText"
    :before-close="beforeClose"
    @confirm="confirm"
    @cancel="cancel"
    @closed="close"
  >
    <div class="dialog-content">
      <div
        class="height-100"
        v-if="data.confirmText"
      >{{ data.confirmText }}</div>
      <div v-else-if="data.confirmObj">
        <van-row
          v-for="(item,index) in data.confirmObj"
          :key="index"
        >
          <van-col
            span="12"
            :class="{ 'space' : item.space }"
          >{{ item.key }}</van-col>
          <van-col
            span="12"
            :class="{ 'space' : item.space }"
          >{{ item.value }}</van-col>
        </van-row>
      </div>

      <div
        class="content-text"
        v-if="data.confirmText2"
      >
        <span
          v-for="(item, index) in data.confirmText2"
          :key="index"
          :class="[`color-${item.color}`]"
        >{{ item.text }}</span>
      </div>
      <div
        class="content-text content-text-big"
        v-if="data.confirmText3"
      >
        <div
          v-for="(item, index) in data.confirmText3"
          :key="index"
          :class="[`color-${item.color}`]"
        >{{ item.text }}</div>
      </div>
    </div>
  </van-dialog>
</template>

<script>
const initData = () => {
  return {
    title: '提示',
    isCancelDelay: false,
    isConfirmDelay: false,
    delaySeconds: 5,
    showCancelButton: true,
    showConfirmButton: true,
    cancelButtonText: '取消',
    confirmButtonText: '确认',
    confirmText: null,
    confirmObj: null
  };
};
export default {
  name: 'ConfirmDialog',
  data() {
    return {
      show: false,
      data: initData(),
      timer: null,
      counter: 3,
      cancelButtonText: '知道了（3）',
      confirmButtonText: '知道了（3）',
      canClose: false // 是否可关闭
    };
  },
  watch: {
    show(val) {
      console.log('----val-', val);
      if (!val) {
        this.data.confirmCallback = null;
        this.data.cancelCallback = null;
      }
    }
  },
  destroyed() {
    this.clearTimer();
  },
  methods: {
    open(data) {
      console.log('----打开框-----', this.show);
      this.data = initData();
      data && (this.data = { ...this.data, ...data });
      this.show = true;
      if (this.data.isCancelDelay || this.data.isConfirmDelay) {
        this.counter = this.data.delaySeconds;
        this.initTimer();
      }
    },
    close() {
      this.show = false;
      console.log('----关闭弹框-', this.show);
    },
    confirm() {
      console.log('----confirm-', this.data.isConfirmDelay && !this.canClose);

      if (this.data.isConfirmDelay && !this.canClose) {
        return;
      }
      this.close();
      this.data.confirmCallback && this.data.confirmCallback.apply(this);
    },
    cancel() {
      if (this.data.isCancelDelay && !this.canClose) {
        return;
      }
      this.close();
      this.data.cancelCallback && this.data.cancelCallback.apply(this);
    },
    beforeClose(action, done) {
      if (action === 'confirm') {
        if (this.data.isConfirmDelay) {
          if (this.canClose) {
            done();
          } else {
            done(false);
          }
        } else {
          done();
        }
      } else if (action === 'cancel') {
        if (this.data.isCancelDelay) {
          if (this.canClose) {
            done();
          } else {
            done(false);
          }
        } else {
          done();
        }
      }
    },
    dealButtonText() {
      if (this.counter > 0) {
        if (this.data.isCancelDelay) {
          this.cancelButtonText = `${this.data.cancelButtonText}（${this.counter}）`;
        }
        if (this.data.isConfirmDelay) {
          this.confirmButtonText = `${this.data.confirmButtonText}（${this.counter}）`;
        }
        this.counter--;
        this.canClose = false;
      } else {
        if (this.data.isCancelDelay) {
          this.cancelButtonText = this.data.cancelButtonText;
        }
        if (this.data.isConfirmDelay) {
          this.confirmButtonText = this.data.confirmButtonText;
        }
        this.canClose = true;
        this.clearTimer();
      }
      console.log('dealButtonText2', this.confirmButtonText, this.counter);
    },
    initTimer() {
      if (this.timer) {
        return;
      }
      this.dealButtonText();
      this.timer = setInterval(this.dealButtonText, 1000);
    },
    clearTimer() {
      if (this.timer) {
        clearInterval(this.timer);
        this.timer = null;
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.custom-dialog{
  &.van-dialog ::v-deep {
    .van-dialog__header{
      padding: 14px 0;

      text-align: center;

      color: #383838;
      border-radius: 8px 8px 0px 0px;
      background: #FFFFFF;
      box-shadow: inset 0px -1px 0px 0px rgba(230,230,230,1);

      font-family: PingFangSC-Regular;
      font-size: 16px;
      font-weight: 400;
    }
    .van-dialog__content{
      .dialog-content{
        padding: 8px 16px 24px;

        text-align: center;
        letter-spacing: -0.41px;

        color: #646464;

        font-family: PingFangSC-Regular;
        font-size: 16px;
        font-weight: 400;
        line-height: 22px;

        .height-100{
          padding-top: 16px;
          overflow-y: auto;

          max-height: 100px;
        }

        .content-text{
          padding: 16px 4px 0;
          overflow-y: auto;

          max-height: 120px;
          &.content-text-big{
            max-height: 250px;
            text-align: left;
          }
          .color-red{
            color: #F32222;
          }
        }

        .van-row{
          .van-row{
            padding-top: 16px;
          }
          .van-col{
            text-align: left;
            & + .van-col{
              text-align: right;

              color: #383838;

              font-family: PingFangSC-Medium;
              font-weight: 500;
            }
          }
        }
      }
    }
    .space {
        margin-top: 16px;
    }
    .van-dialog__footer {
      padding: 0 16px 24px;
      .van-button {
        height: 40px;

        text-align: center;
        letter-spacing: -0.41px;

        & + .van-button {
          margin-left: 17px;
        }
        &.van-dialog__cancel {
          color: #646464;
          border-radius: 8px;
          background: #EDF2F7;

          font-family: PingFangSC-Regular;
          font-size: 16px;
          font-weight: 400;
        }
        &.van-dialog__confirm {
          color: #ffffff;
          border-radius: 8px;
          background: #3399FF;

          font-family: PingFangSC-Regular;
          font-size: 16px;
          font-weight: 400;
        }
      }
    }
  }
}
</style>
